export function scrollToLocation() {
    var _hash = window.location.hash.replace(/\//g, "");
    if (_hash.length > 0) {
        var _id = _hash.replace(/#/gi, '');
        var to = $('[data-id="' + _id + '"]').offset().top - $(".header").innerHeight();
        $('html, body').animate({scrollTop: to}, 800);
        window.history.pushState("", document.title, window.location.pathname);
    }

    document.addEventListener("DOMContentLoaded", function () {
        var _get_params = window
            .location
            .search
            .replace('?', '')
            .split('&')
            .reduce(
                function (p, e) {
                    var a = e.split('=');
                    p[decodeURIComponent(a[0])] = decodeURIComponent(a[1]);
                    return p;
                },
                {}
            );

        if (_get_params['location']) {

            var _location = _get_params['location'];
            $(".menu-section .menu-gallery").slick('slickGoTo', 0);
            $('.menu-listing .tab-menu[data-slide="0"]').addClass('active');
            $('.wide-poster').removeClass('show').addClass('hide');
            $('.wide-poster[data-location="' + _location + '"]').removeClass('hide').addClass('show');
            $('.menu-listing .menu-tabs').attr('hidden', true);
            $('.menu-tabs').hide();
            $('#' + _location +'-1').attr('hidden', false).show();

            var to = $('[data-location="' + _location + '"]').offset().top - $(".header").innerHeight();
            $('html, body').animate({scrollTop: to}, 800);
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/scroll-to-location.js